import React, { useState, useEffect } from "react";

interface BeforeInstallPromptEvent extends Event {
  readonly platforms: string[];
  readonly userChoice: Promise<{
    outcome: "accepted" | "dismissed";
    platform: string;
  }>;
  prompt(): Promise<void>;
}

const PWAInstallBanner: React.FC = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handler = (e: Event) => {
      // Retenir l'invite du navigateur pour la rejouer depuis la bannière.
      e.preventDefault();
      setDeferredPrompt(e as BeforeInstallPromptEvent);
      setIsVisible(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();

    // Attendre la réponse avant de retirer la bannière. L'invite ne se rejoue
    // pas : acceptée ou refusée, l'événement est consommé.
    await deferredPrompt.userChoice;

    setDeferredPrompt(null);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 z-50">
      <div className="alert shadow-lg bg-base-100 border-primary">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-primary shrink-0 w-6 h-6">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        <div>
          <h3 className="font-bold">Installer l'application</h3>
          <div className="text-xs">Ajoutez TPP Traçabilité à votre écran d'accueil pour un accès rapide.</div>
        </div>
        <div className="flex-none">
          {/* « Plus tard » masque la bannière jusqu'au prochain chargement, et ne la repropose pas : voulu, pas un oubli. */}
          <button className="btn btn-sm btn-ghost" onClick={() => setIsVisible(false)}>Plus tard</button>
          <button className="btn btn-sm btn-primary" onClick={handleInstallClick}>Installer</button>
        </div>
      </div>
    </div>
  );
};

export default PWAInstallBanner;
